import { Link } from "react-router-dom";

const Section = () => {
  return (
    <>
      <section className="section section-ow">
        <div className="container container-center">
          <h1>technologies</h1>
          <p>
            <strong>Languages -</strong> JavaScript, Java, HTML5/CSS3,
            TypeScript, MySQL, Node.js
          </p>
          <p>
            <strong>Library/Frameworks -</strong> React.js , Spring Boot,
            Context API, Redux-Toolkit
          </p>
          <p>
            <strong>Testing Library -</strong> Jest, JUnit, Robot Framework
          </p>
          <p>
            <strong>CSS Frameworks -</strong> Bootstrap, Tailwind CSS
          </p>
          <p>
            <strong>DevOps Tools -</strong> Jenkins, SonarQube
          </p>
          <p>
            <strong>Project Management Tools -</strong> Jira, BitBucket, GitHub
          </p>
          <p>
            <strong>API Tools -</strong> Postman, Swagger
          </p>
          <p>
            <strong>Version Control -</strong> Git
          </p>
          <p>
            <strong>Other utilities -</strong> Firebase, Oracle DB
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container container-center">
          <h1>projects</h1>
          <p>List of all projects I made during the course of my learning</p>
          <Link to="project" className="link link-primary">
            Browse projects
          </Link>
        </div>
      </section>

      <section className="section section-ow">
        <div className="container container-center">
          <h1>blogs</h1>
          <p>On my way, I wrote few articles which I found interesting</p>
          <Link to="/blog" className="link link-secondary">
            Read blogs
          </Link>
        </div>
      </section>
    </>
  );
};

export default Section;
